import React, { useEffect, useContext } from 'react'
import styles from './Unauthorized.module.scss'
import AuthContext from '../../context/auth'

const Unauthorized = (props) => {
  const authContext = useContext(AuthContext);
  const { authenticated, subcribed } = authContext;
  
  useEffect(() => {
    if(authenticated && !subcribed){
      props.history.push('/signup/plans');
    }
  }, [authenticated, subcribed, props.history])

  return (
    <div className={styles.Container}>
      <div className="text-center">
        <h1 className={styles.Status}>401</h1>
        <h2 className={styles.Message}>Unauthorized</h2>
      </div>
    </div>
  )
}

export default Unauthorized
